import React from 'react';

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      data-testid='icon_close'
      width='24'
      height='24'
      fill='none'
      viewBox='0 0 24 24'
    >
      <path fill='none' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M18 6L6 18' />
      <path fill='none' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M6 6l12 12' />
    </svg>
  );
}

export default Icon;
